// Fonction utilitaire pour transformer une chaîne en nombre
const parseIntSafe = (value: string) => parseInt(value);

export default parseIntSafe;
